import styled from 'styled-components';

interface PaperProps {
  border?: boolean;
  maxWidth?: number;
  height?: number;
}

export const PaperStyled = styled.div<PaperProps>`
  border-radius: 5px;
  background-color: white;
  max-width: ${({ maxWidth }) => maxWidth + 'px' || 'unset'};
  width: 100%;
  height: ${({ height }) => height + 'px' || '100%'}!important;
  border: ${({ border }) => (border ? '1px solid #e7e8f2' : 'unset')};
`;
